<template>
  <div id="workOrderInfo_exit">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 35%;">
      <p class="headerT fl" style="width: 120px;">工单信息</p>
      <el-button class="fl" size="small"  type="danger" style="margin: -5px 0 0 0px;">待确认</el-button>
      <!-- <el-button class="fl" size="small"  type="success" style="margin: -5px 0 0 0px;">已确认</el-button> -->
      <el-button class="fl" size="small"  type="danger" style="margin: -5px 0 0 20px;">未指派工程师</el-button>
      <i @click="dolikes()" class="el-icon-star-off fl" style="font-size:20px;margin-left: 20px;" :class="{'StarOn':highStar}"></i>

      <div class="clearfix"></div>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="工单编号">
          <el-input disabled v-model="orderInfoForm.orderNumber">
            <template slot="append" v-if="orderInfoForm.afterSalesNum !== 0">
              售后数:{{orderInfoForm.afterSalesNum}}
            </template>
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.orderNumber,$event)"></i>
          
        </el-form-item>
        <el-form-item label="售后订单" v-if="orderInfoForm.afterSalesNum !== 0">
          <el-input disabled v-model="orderInfoForm.olderOrderCode">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.olderOrderCode,$event)"></i>

        </el-form-item>
        <el-form-item label="原始工单" v-if="orderInfoForm.afterSalesNum !== 0">
          <el-input disabled v-model="orderInfoForm.orderNumber">
            <template slot="append" v-if="orderInfoForm.afterSalesNum !== 0">
              售后数:{{orderInfoForm.afterSalesNum}}
            </template>
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.orderNumber,$event)"></i>
        </el-form-item>
        <el-form-item label="工单类型"  prop="orderType">
          <el-select v-model="orderInfoForm.orderType" placeholder="请选择工单类型" style="width: 100%;">
            <el-option label="上门维修" value="orderType001"></el-option>
            <el-option label="上门售后" value="orderType002"></el-option>
            <el-option label="到店维修" value="orderType003"></el-option>
            <el-option label="到店售后" value="orderType004"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道来源"  prop="orderSource">
          <el-select disabled v-model="orderInfoForm.orderSource" placeholder="请选择渠道来源" style="width: 100%;">
            <el-option label="电话" value="eeww"></el-option>
            <el-option label="微信" value="rere"></el-option>
            <el-option label="微博" value="hghg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input v-model="orderInfoForm.clientName" ></el-input>

        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="orderInfoForm.clientPhone" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.clientPhone,$event)"></i>

         </el-form-item>
        <el-form-item label="省市区">
          <el-select
                style="width: 30%;"
                v-model="sheng"
                @change="choseProvince"
                placeholder="省级地区">
                <el-option
                  v-for="item in province"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select
                style="width:28%;"
                v-model="shi"
                @change="choseCity"
                placeholder="市级地区">
                <el-option
                  v-for="item in shi1"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select
                style="width:28%;"
                v-model="qu"
                @change="choseBlock"
                placeholder="区级地区">
                <el-option
                  v-for="item in qu1"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="orderInfoForm.clientAddress" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(sheng+shi+qu+orderInfoForm.clientAddress,$event)"></i>

         </el-form-item>
        <el-form-item label="预约时间">
          <!-- <el-input v-model="orderInfoForm.appoTime" ></el-input> -->
          <el-date-picker
            style="width:30%"
            v-model="orderInfoForm.appoTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
          <el-time-select
            style="width:28%"
            placeholder="起始时间"
            v-model="startTime"
            :picker-options="{
              start: '08:30',
              step: '02:00',
              end: '18:30'
            }">
          </el-time-select>
          <el-time-select
            style="width:28%"
            placeholder="结束时间"
            v-model="endTime"
            :picker-options="{
              start: '08:30',
              step: '02:00',
              end: '18:30',
              minTime: startTime
            }">
          </el-time-select>
        </el-form-item>
      </el-form>
      
      <p class="headerT">维修信息</p>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="IMEI" prop="IMEI">
          <el-input disabled v-model="orderInfoForm.IMEI" ></el-input>
          <!-- <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.clientPhone,$event)"></i> -->
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-select v-model="orderInfoForm.brand" placeholder="请选择渠道来源" style="width: 100%;">
            <el-option label="电话" value="eeww"></el-option>
            <el-option label="微信" value="rere"></el-option>
            <el-option label="微博" value="hghg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品类" prop="category">
          <el-select v-model="orderInfoForm.category" placeholder="请选择品类" style="width: 100%;">
            <el-option label="电话" value="eeww"></el-option>
            <el-option label="微信" value="rere"></el-option>
            <el-option label="微博" value="hghg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-select v-model="orderInfoForm.model" placeholder="请选择型号" style="width: 100%;">
            <el-option label="电话" value="eeww"></el-option>
            <el-option label="微信" value="rere"></el-option>
            <el-option label="微博" value="hghg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-select v-model="orderInfoForm.color" placeholder="请选择颜色" style="width: 100%;">
            <el-option label="红色" value="eeww"></el-option>
            <el-option label="黄色" value="rere"></el-option>
            <el-option label="黑色" value="hghg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="故障分类" prop="faultClass">
          <el-checkbox-group v-model="faultClassCheckList">
            <el-checkbox label="故障分类1" name="type" style="width: 50%;margin: 0;"></el-checkbox>
            <el-checkbox label="故障分类2" name="type" style="width: 50%;margin: 0;"></el-checkbox>
            <el-checkbox label="故障分类3" name="type" style="width: 50%;margin: 0;"></el-checkbox>
            <el-checkbox label="故障分类4" name="type" style="width: 50%;margin: 0;"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="故障" prop="fault">
            <el-checkbox-group v-model="faultCheckList">
            <el-checkbox label="故障1" name="type"></el-checkbox>
            <el-checkbox label="故障2" name="type"></el-checkbox>
            <el-checkbox label="故障3" name="type"></el-checkbox>
            <el-checkbox label="故障4" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <p class="headerT">支付信息</p>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="故障金额" prop="faultPrice">
          <el-input disabled v-model="orderInfoForm.faultPrice" ></el-input>
        </el-form-item>
        <el-form-item label="折扣" prop="discount">
          <el-select v-model="orderInfoForm.discount" placeholder="请选择折扣" style="width: 100%;">
            <el-option label="95折" value="95"></el-option>
            <el-option label="9折" value="90"></el-option>
            <el-option label="85折" value="85"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应付金额" prop="sum">
          <div style="width: 85%;background-color: #f5f7fa;border-color: #e4e7ed;color: #c0c4cc;cursor: not-allowed;    border-radius: 4px;border: 1px solid #dcdfe6;padding-left: 10px;" v-model="orderInfoForm.sum">{{Math.round(orderInfoForm.discount/100*orderInfoForm.faultPrice)}}</div>
          <!-- <el-input disabled v-model="sumPrice"></el-input> -->
        </el-form-item>
        
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 62%;">
      <el-button-group style="margin-bottom: 20px;">
        <el-button :class="{activeBtn:activeBtnIndex === index}" v-for="(item,index) in orderStates" @click="changeState(item,index)" :key="index">{{item.name}}
          <span v-if="workorderReply.length !== 0 && index == 0">({{workorderReply.length}})</span>
        </el-button>
      </el-button-group>
      <!-- <p class="headerT">供应商信息详情</p> -->
      <el-card class="box-card fr" style="width: 100%;" v-if="activeBtnIndex ==0">
        <ul>
          <li v-for="(item,index) in workorderReply" :key="index" class="replyLi">
            <el-row>
              <el-col :span="4" style="width: 75px;">
                <span class="headPic" :class="{ headUser1: item.replyer === 1, headUser2: item.replyer === -1 }"></span>
              </el-col>
              <el-col :span="18">
                <span v-if="item.replyer === 1" class="fl">客服</span>
                <span v-if="item.replyer === -1" class="fl">工程师</span>
                <span class="createUser fl">{{item.createUser}}</span>
                <span class="createTime childSpan clearfix" v-if="item.createTime">
                  <i class="fl"></i>
                  <span class="fl">{{formatTime(item.createTime)}}</span><br>
                </span>
                <span class="details childSpan" v-if="item.details">{{item.details}}<br></span>
                
              </el-col>
              <el-col :span="2" style="position: relative;height: 80px;">
                <el-button size="small" type="danger" style="position: absolute;bottom: 0;margin-left: 10px;">删除回复</el-button>
              </el-col>
            </el-row>
            
          </li>
        </ul>
        <quill-editor ref="myTextEditor" v-model="content" :options="editorOption"></quill-editor>
      </el-card>
      <el-row  v-if="activeBtnIndex ==1">
        <ul>
          <li v-for="(item,index) in workOrderEvent" :key="index" class="eventLi">
            <span class="createTime childSpan clearfix" v-if="item.createTime">
              <i class="fl"></i>
              <span class="fl">{{formatTime(item.createTime)}}</span><br>
            </span>
            <span class="details childSpan" v-if="item.details">{{item.details}}<br></span>
            <span class="attribute1 childSpan" v-if="item.attribute1">
              {{item.attribute1.substring(0,item.attribute1.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute1.substring(item.attribute1.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute2 childSpan" v-if="item.attribute2">
              <!-- {{item.attribute2}}<br> -->
              {{item.attribute2.substring(0,item.attribute2.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute2.substring(item.attribute2.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute3 childSpan" v-if="item.attribute3">
              <!-- {{item.attribute3}}<br> -->
              {{item.attribute3.substring(0,item.attribute3.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute3.substring(item.attribute3.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
          </li>
        </ul>
        <!-- <h2>{{valueTime}}</h2> -->
      </el-row>
       <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 0;">
        提交为
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="DetermineSave()">已确认</el-dropdown-item>
          <el-dropdown-item @click.native="temporarySave()">暂存</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
        {{pageStatus}}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
          <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="submitEditor()">提交</el-button>
    </el-col>
  </div>
</template>

<script>
  let moment = require("moment");
  import Vue from 'vue'
  import axios from 'axios'
  import clip from '@/util/clipboard'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'
  import {
      
    } from "../../api/api";
  export default {
    name: 'workOrderInfo_exit',
    components: {
      quillEditor
    },
    data () {
      return {
        highStar:false,
        startTime:'8:30',
        endTime:'10:30',
        pageStatus:'留在当前页面',
        content:'',
        editorOption: {
          placeholder: 'Hello World'
        },
        faultClassCheckList:['故障分类1'],
        faultCheckList:['故障1','故障2'],
        orderInfoForm:{
          orderType:'上门维修',
          orderNumber:'JHH201808140002',
          olderOrderCode:'JHH201808140001',
          afterSalesNum:1,
          orderSource:'微信',
          clientName:'李先生',
          clientPhone:'18966551245',
          orderInfoTime:'',
          clientAddress:'凯阳大厦5楼极吼吼',
          appoTime:'2019-1-15',
          IMEI:'232323232323',
          brand:'苹果 APPLE',
          category:'iPhone',
          model:'iPhone X',
          color:'金色',
          faultClass:'',
          fault:'',
          faultPrice:599,
          discount:95,
          sum:null
        },
        mapJson:'../static/json/map.json',
        province:'',
        sheng: '上海市',
        shi: '上海市',
        shi1: [],
        qu: '长宁区',
        qu1: [],
        city:'',
        block:'',
        valueTime:'',
        orderId:'',
        activeBtnIndex:0,
        orderStates:[{name:'工单回复'},{name:'工单事件'},],
        labelPosition:'left',
        returnDataNumber: [
          { 
            orderNumber:'JHH12345678',
            model:'iPhone 6 银色', 
            fault:'外屏碎', 
            repairTime:'2018.08.25 07:35:26', 
            userInfo:'许*凯 135****1234上海市长宁区定西路788号5G极吼吼', 
            times:'1', 
          },
        ],
        returnData: [
          { 
            materialCoding:'',
            materialName:'', 
            number:'', 
            price:'', 
            amout:'', 
            aogSum:'', 
            aogPercentage:'', 
            salesReturnSum:'', 
            salesReturnPercentage:'',
          },
        ],
        //分页变量
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
        workorderReply:[
          {
            replyer:1,
            createUser:"张QQ",
            createTime:1545381170000,
            details:'巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉拉巴拉巴拉巴拉巴拉巴拉拉巴拉巴拉巴拉巴拉巴拉',
          },
          {
            createUser:"王HH",
            replyer:1,
            createTime:1545381170000,
            details:'巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉拉巴拉巴拉巴拉巴拉巴拉拉巴拉巴拉巴拉巴拉巴拉',
          },
          {
            createUser:"李MM",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"王工程师",
            replyer:-1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"白YY",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"赵 pp",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"赵 pp",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"赵 pp",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"赵 pp",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
          {
            createUser:"赵 pp",
            replyer:1,
            createTime:1545381170000,
            details:'hjhjdhjdshjdshdj',
          },
        ],
        workOrderEvent:[
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        ],
        workOrderEvent:[
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        {
          createTime:1545381170000,
          details:'hjhjdhjdshjdshdj',
        },
        ]


      }
    },
    mounted () {
      // if (!this.$route.query.orderId) {
      //   var userOrderId = sessionStorage.getItem('saveOrderId');
      //   this.orderId = JSON.parse(userOrderId);
      // }else{
      //   let orderId = this.$route.query.orderId
      //   this.orderId = orderId
      // }
      // this.getPurchaseOrdersInfo()
      // if (this.returnData.amout > 0) {
      //   this.returnData.amout = this.toThousands2(this.returnData.amout)
      // }
      
    },
    methods: {
       
      dolikes(){
        console.log(this.highStar)
        if (this.highStar === true) {
          this.highStar = false
        } else {
          this.highStar = true
        }
      },
      //清空
      emptyDialog(){
        console.log('dsdsd')
      },
      // 加载china地点数据，三级
      getCityData:function(){
        var that = this
        axios.get(this.mapJson).then(function(response){
          if (response.status==200) {
            var data = response.data
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (var item in data) {
              if (item.match(/0000$/)) {//省
                that.province.push({id: item, value: data[item], children: []})
              } else if (item.match(/00$/)) {//市
                that.city.push({id: item, value: data[item], children: []})
              } else {//区
                that.block.push({id: item, value: data[item]})
              }
            }
            // 分类市级
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                  that.province[index].children.push(that.city[index1])
                }
              }
            }
            // 分类区级
            for(var item1 in that.city) {
              for(var item2 in that.block) {
                if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                  that.city[item1].children.push(that.block[item2])
                }
              }
            }
          }
          else{
            console.log(response.status)
          }
        }).catch(function(error){console.log(typeof+ error)})
      },
      // 选省
      choseProvince:function(e) {
        for (var index2 in this.province) {
          if (e === this.province[index2].id) {
            this.shi1 = this.province[index2].children
            this.shi = this.province[index2].children[0].value
            this.qu1 =this.province[index2].children[0].children
            this.qu = this.province[index2].children[0].children[0].value
            this.E = this.qu1[0].id
          }
        }
      },
      // 选市
      choseCity:function(e) {
        for (var index3 in this.city) {
          if (e === this.city[index3].id) {
            this.qu1 = this.city[index3].children
            this.qu = this.city[index3].children[0].value
            this.E = this.qu1[0].id
            // console.log(this.E)
          }
        }
      },
      // 选区
      choseBlock:function(e) {
        this.E=e;
        // console.log(this.E)
      },
      //时间转化函数
      formatTime (ndate) {
        if (!ndate) {
          return '-'
        }
        const date = new Date(ndate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var day = date.getDate()
        var hour = date.getHours()
        var minute = date.getMinutes()
        var second = date.getSeconds()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (day >= 0 && day <= 9) {
          day = '0' + day
        }
        if (hour >= 0 && hour <= 9) {
          hour = '0' + hour
        }
        if (minute >= 0 && minute <= 9) {
          minute = '0' + minute
        }
        if (second >= 0 && second <= 9) {
          second = '0' + second
        }
        var result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
        return result
      },
      //金额转化函数
      addCommas:function(row,column){
        var num = row[column.property];
        var b= num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      toThousands2(num) {
        // this.materForm.backUpPrice = num
        // var num = row[column.property];
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      //获取订单详情
      getPurchaseOrdersInfo() {
        let para={
          id: this.orderId,
        }
        getPurchaseOrdersInfo(para).then(res => {          
          if (res.data.status==100) {            
            // console.log(res.data.results)  
            this.returnData = res.data.results.purchaseDetails.list
            this.returnData.forEach((item) =>{
              return item.amout = item.price*item.number
            })
            // this.returnData.amout = this.returnData.number * this.returnData.price 
            this.purchaseForm = res.data.results.purchaseOrdersInfo
            this.purchaseForm.purchaseTime = moment(res.data.results.purchaseOrdersInfo.purchaseTime).format("YYYY-MM-DD");
            this.purchaseForm.aogTime = moment(res.data.results.purchaseOrdersInfo.aogTime).format("YYYY-MM-DD");
            sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.purchaseOrdersInfo.id));
            // this.workOrderEvent = res.data.results.workOrderEvent
            
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //取消订单
      cancelOrder(){//delPurchasingInfo
        let para={
          id:this.purchaseForm.id,
        }
        // console.log(para)
        purchaseOrdersClose(para).then(res => {
          if (res.data.status==100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path:'/purchaseOrderManage'
            })
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        
      },
      tabRemove (targetName) {
          // 首页不可删除
          if(targetName == '/') {
            return;
          }
          //将该tab从options里移除
          this.$store.commit('delete_tabs', targetName);
          ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
          if (this.activeIndex === targetName) {
            // 设置当前激活的路由
            if (this.options && this.options.length >= 1) {
              this.$store.commit('set_active_index', this.options[this.options.length-1].route);
              this.$router.push({path: this.activeIndex});
            } else {
              this.$router.push({path: '/welcome'});
            }
          }
        },
      //复制内容
      handleCopy(text, event) {
         clip(text, event)
         console.log(text)
      },
      //返回上一页
      backGo() {
        this.$router.push({
          path:'/workOrderManage'
        })
      },
      refresh() {
        this.getPurchaseOrdersInfo()
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 4) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });
        if (sums[5] > 0) {
          sums[5] = this.toThousands2(sums[5]);
        }
        return sums;
      },
     //切换订单详情与订单事件
      changeState(item,index) {
        this.activeBtnIndex = index
       },
       handleSizeChange(val) {
        this.pages.pageSize = val
        this.getPurchaseOrdersList()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getPurchaseOrdersList()
      },
      onEditorChange({ editor, html, text }) {
        this.content = html
      },
      submitEditor() {
        console.log(this.content)
        this.$message.success('提交成功！')
      },
      //已提交
      DetermineSave(){
        this.saveStatus = 'YQR';
        if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
          supplier: this.purchaseOrderForm.supplier,
          supplierName: this.purchaseOrderForm.supplierName,
          paymentTime: this.purchaseOrderForm.paymentTime,
          purchaseTime: this.purchaseOrderForm.purchaseTime,
          aogTime: this.purchaseOrderForm.aogTime,
          status: this.saveStatus,
          amout: this.backupAmout,
          sum: this.sum,
          purchaseDetails: this.returnData,
        }
        // console.log(para)
        purchaseOrdersAdd(para).then(res => {
          if (res.data.status==100) {
            // this.$message({
            //   message: res.data.message,
            //   type: "success"
            // });
            if (this.pageStatus == '留在当前页面') {
              this.dialogVisible = false
              this.purchaseOrderForm = {}
              this.returnData = []
            }else{
              // parent.location.reload();
              this.tabRemove(this.$route.path)
              this.$router.replace({
                path:'/purchaseOrderManage'
              })
            }
           
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        }
      },
      closeSave(){
        // alert('1111')
        this.pageStatus = "离开当前页面"
        
      },
      goOnSave(){
        this.pageStatus = "留在当前页面"
        
      },
      //暂存
      temporarySave(){
        this.saveStatus = 'CG';
        if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
          supplier: this.purchaseOrderForm.supplier,
          supplierName: this.purchaseOrderForm.supplierName,
          paymentTime: this.purchaseOrderForm.paymentTime,
          purchaseTime: this.purchaseOrderForm.purchaseTime,
          aogTime: this.purchaseOrderForm.aogTime,
          status: this.saveStatus,
          amout: this.backupAmout,
          sum: this.sum,
          purchaseDetails: this.returnData,
        }
        // console.log(para)
        purchaseOrdersAdd(para).then(res => {
          if (res.data.status==100) {
            if (this.pageStatus == '留在当前页面') {
              this.dialogVisible = false
              this.purchaseOrderForm = {}
              this.returnData = []
            }else{
              // parent.location.reload();
              this.tabRemove(this.$route.path)
              this.$router.replace({
                path:'/purchaseOrderManage'
              })
            }
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        }
      },
    },
    created:function(){
      this.getCityData()
    },
    
  }
</script>

<style type="text/css" lang="scss" scoped>
  #workOrderInfo_exit{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .el-input{width: 85%;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .StarOn{color:#f4ea2a;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
      .childSpan{padding-left: 20px;margin-bottom: 5px;}
      .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
      .childSpan span.orderId{color: #3399FF;}
      .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
        background-color: #1abc9c;margin: 0px 15px 0px -5px;}

    }
    .replyLi{margin-bottom: 20px;
      .headPic{width: 50px;height: 50px;background: url(../../assets/images/customerImg.png) no-repeat 0 0; display: inline-block;}
      .headUser1{background-image: url(../../assets/images/engineerImg.png);}
      .createUser{
        padding: 0 5px;color:#1abc9c;
      }
      .details{
        background-color: #f9f9f9;padding: 10px;display: inline-block;line-height: 20px;color: #999;
      }
    }
    .toolbar{float: none;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    .el-input--suffix .el-input__inner {
      padding-right: 10px;
    }
    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text{border-color: #1abc9c;}
  }
  
</style>



// WEBPACK FOOTER //
// workOrderInfo_exit.vue?3715c7d4